import { apiGet } from 'api-service';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getRequestTimeDuration } from 'utils';
import { contentAdapter } from 'store/content/adapters';
import { setExcelFilters } from '../excelExport/excelExportSlice';

export const fetchStoriesGeneric = createAsyncThunk(
  'storyReducer/fetchStoriesGeneric',
  async (
    {
      apiPath,
      apiPathParams,
      loadMore = false,
      page = 1,
      brandId = [],
      useFilters = false,
      ...rest
    },
    thunkAPI
  ) => {
    const { currentDate } = thunkAPI.getState().pageReducer;
    const filters = useFilters ? thunkAPI.getState().storyReducer.filters : {};

    const defaultParams = {
      api_path: apiPathParams,
      sort: 'time',
      count: 15,
      page,
      want_vip_flag: 1,
      from: currentDate.timeDuration ? undefined : currentDate.fromDate,
      to: currentDate.timeDuration ? undefined : currentDate.toDate,
      time_duration: getRequestTimeDuration(currentDate),
      ...(brandId.length > 0 ? { brand_id: brandId } : {}),
      ...(useFilters
        ? {
            [filters?.resourcesFilter?.selectedValue === 'include'
              ? 'resource_ids'
              : 'not_resource_ids']: Object.keys(
              filters?.resourcesFilter?.selectedItems || {}
            ),
            [filters?.resourceCategoryFilter?.filterType === 'include'
              ? 'tag_id'
              : 'not_tag_id']:
              filters?.resourceCategoryFilter?.selectedValue || undefined,
            post_resource_ids: Object.keys(
              filters?.resourcesFilter?.selectedItems || {}
            ),
          }
        : {}),
      ...rest,
    };

    if (useFilters) {
      thunkAPI.dispatch(
        setExcelFilters({
          params: { ...defaultParams },
          exportPage: 'content',
          exportPlatform: apiPath.includes('brand-identity')
            ? 'instagramBrandBaanStories'
            : 'instagramStories',
        })
      );
    }

    try {
      const response = await apiGet(apiPath, defaultParams);

      return {
        data:
          response.data?.result?.data?.map((story) =>
            contentAdapter(story, 'instagramStories')
          ) || [],
        total: response.data?.result?.meta?.total || 0,
        loadMore,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
